import React from "react"
import autobind from "class-autobind"
import { TextField, Paper } from "material-ui"
import strings from "../../localization/strings"
import { ELanguage, IQuestionExceptionConfirm } from "../../models"
import _ from "lodash"
import ExpandLess from "material-ui/svg-icons/navigation/expand-less"
import ExpandMore from "material-ui/svg-icons/navigation/expand-more"

interface IProps {
    readonly: boolean
    selectedLanguages: ELanguage[]
    exceptionConfirms: IQuestionExceptionConfirm[]
    handleChange(exceptionConfirms: IQuestionExceptionConfirm[]): void
}
interface IState {
    expand: boolean
}

export default class QuestionExceptionConfirm extends React.Component<IProps, IState>  {
    constructor(props: IProps) {
        super(props)
        this.state = {
            expand: false
        }
        autobind(this)
    }

    render() {
        return (
            <Paper style={{ marginTop: 15, padding: 15, position: "relative" }}>
                <div style={{ fontSize: 14 }}>
                    {strings.Exception_Confirm_Screen}
                </div>
                <div
                    data-intercom-target={"QuestionExceptionScreen-Expand"}
                    style={{ position: "absolute", right: 15, top: 15 }}
                    onClick={() => this.setState({ expand: !this.state.expand })}
                >
                    {this.state.expand ? <ExpandLess /> : <ExpandMore />}
                </div>
                {this.state.expand &&
                    <div style={{ display: "flex", justifyContent: "space-between", marginTop: -15, overflowX: "auto", overflowY: "hidden" }}>
                        {this.props.selectedLanguages.map(language =>
                            <QuestionExceptionConfirmItem
                                key={language}
                                readonly={this.props.readonly}
                                selectedLanguages={this.props.selectedLanguages}
                                language={language}
                                exceptionConfirm={this.props.exceptionConfirms.find(i => i.Language === language)}
                                handleAdd={exceptionConfirm => {
                                    const exceptionConfirms = _.cloneDeep(this.props.exceptionConfirms)
                                    exceptionConfirms.push(exceptionConfirm)
                                    exceptionConfirms.sort((a, b) => {
                                        if (a.Language === b.Language) return 0
                                        if (a.Language < b.Language) return -1
                                        if (a.Language > b.Language) return 1
                                    })
                                    this.props.handleChange(exceptionConfirms)
                                }}
                                handleUpdate={exceptionConfirm => {
                                    const exceptionConfirms = _.cloneDeep(this.props.exceptionConfirms)
                                    exceptionConfirms[exceptionConfirms.findIndex(i => i.Language === exceptionConfirm.Language)] = exceptionConfirm
                                    this.props.handleChange(exceptionConfirms)
                                }}
                                handleDelete={() => {
                                    let exceptionConfirms = _.cloneDeep(this.props.exceptionConfirms)
                                    exceptionConfirms = exceptionConfirms.filter(i => i.Language !== language)
                                    this.props.handleChange(exceptionConfirms)
                                }}
                            />
                        )}
                    </div >
                }
            </Paper>
        )
    }
}

interface IExceptionConfirmProps {
    readonly: boolean
    selectedLanguages: ELanguage[]
    language: ELanguage
    exceptionConfirm: IQuestionExceptionConfirm
    handleAdd(exceptionConfirm: IQuestionExceptionConfirm): void
    handleUpdate(exceptionConfirm: IQuestionExceptionConfirm): void
    handleDelete(): void
}
interface IExceptionConfirmState {
    title: string
    errorTitle: string
    btnLabel: string
    errorBtnLabel: string
}

class QuestionExceptionConfirmItem extends React.Component<IExceptionConfirmProps, IExceptionConfirmState> {
    constructor(props: IExceptionConfirmProps) {
        super(props)
        this.state = {
            title: props.exceptionConfirm && props.exceptionConfirm.Title || "",
            errorTitle: "",
            btnLabel: props.exceptionConfirm && props.exceptionConfirm.BtnLabel || "",
            errorBtnLabel: ""
        }
        autobind(this)
    }

    handleChange() {
        if (this.checkValidate()) {
            let exceptionConfirm = _.cloneDeep(this.props.exceptionConfirm)
            if (!exceptionConfirm) {
                exceptionConfirm = {
                    Language: this.props.language,
                    Title: null,
                    BtnLabel: null,
                }
            }
            exceptionConfirm.BtnLabel = this.state.btnLabel.trim()
            exceptionConfirm.Title = this.state.title.trim()

            this.props.exceptionConfirm ?
                this.props.handleUpdate(exceptionConfirm) :
                this.props.handleAdd(exceptionConfirm)
        }
        else {
            this.props.handleDelete()
        }
    }

    checkValidate() {
        let isValid = true

        if (!this.state.title.trim()) {
            this.setState({ errorTitle: strings.This_field_is_required })
            isValid = false
        }
        else {
            if (this.state.title.trim().length > 25) {
                this.setState({ errorTitle: strings.formatString(strings.max_x_chars, 25) as string })
                isValid = false
            }
            else {
                this.setState({ errorTitle: "" })
            }
        }

        if (!this.state.btnLabel.trim()) {
            this.setState({ errorBtnLabel: strings.This_field_is_required })
            isValid = false
        }
        else {
            if (this.state.btnLabel.trim().length > 15) {
                this.setState({ errorBtnLabel: strings.formatString(strings.max_x_chars, 15) as string })
                isValid = false
            }
            else {
                this.setState({ errorBtnLabel: "" })
            }
        }

        return isValid
    }

    render() {
        return (
            <div style={{ display: "flex" }}>
                <TextField
                    data-intercom-target={"QuestionExceptionScreen-Entry-Title"}
                    name="title"
                    disabled={this.props.readonly}
                    floatingLabelText={this.props.selectedLanguages.length === 1 ?
                        strings.Title :
                        strings.formatString(strings.Title_langX, ELanguage[this.props.language])
                    }
                    style={{ flex: this.props.selectedLanguages.length > 1 && 1, width: 175, marginRight: 20 }}
                    value={this.state.title}
                    onChange={(e, value) => this.setState({ title: value }, () => this.handleChange())}
                    errorText={this.state.errorTitle}
                    errorStyle={{ position: "absolute", bottom: -10 }}
                />
                <TextField
                    data-intercom-target={"QuestionExceptionScreen-Entry-BtnLabel"}
                    name="btnLabel"
                    disabled={this.props.readonly}
                    floatingLabelText={this.props.selectedLanguages.length === 1 ?
                        strings.Button_Label :
                        strings.formatString(strings.Button_Label_langX, ELanguage[this.props.language])
                    }
                    style={{ flex: this.props.selectedLanguages.length > 1 && 1, width: 175, marginRight: 20 }}
                    value={this.state.btnLabel}
                    onChange={(e, value) => this.setState({ btnLabel: value }, () => this.handleChange())}
                    errorText={this.state.errorBtnLabel}
                    errorStyle={{ position: "absolute", bottom: -10 }}
                />
            </div>
        )
    }
}